import { Typography } from '@material-ui/core'

/**
 * `Copyright` component declaration.
 * @return CopyRight
 */
const Copyright = (): JSX.Element => {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {`Copyright © Justiexpress ${new Date().getFullYear()}.`}
    </Typography>
  )
}

export default Copyright